'use client'

import type { PropsWithChildren } from 'react'
import { Button, type ButtonProps } from '../../buttons/button.tsx'

export const ConfirmationModalButton = (props: ButtonProps) => {
  return <Button {...props} />
}

export type ConfirmationModalCancelButtonProps = PropsWithChildren<{
  onCancel?: () => void
  disabled?: boolean
  loading?: boolean
}> &
  Pick<
    ButtonProps,
    'dataTestId' | 'dataTrackingId' | 'disabled' | 'loading' | 'variant'
  >

export const ConfirmationModalCancelButton = ({
  dataTestId,
  dataTrackingId,
  disabled,
  loading,
  onCancel,
  children,
  variant = 'text',
}: ConfirmationModalCancelButtonProps) => {
  return (
    <Button
      variant={variant}
      disabled={disabled}
      loading={loading}
      onClick={onCancel}
      dataTestId={dataTestId}
      dataTrackingId={dataTrackingId}
    >
      {children}
    </Button>
  )
}

export type ConfirmationModalConfirmButtonProps = PropsWithChildren<{
  onConfirm?: () => void
}> &
  Pick<
    ButtonProps,
    'dataTestId' | 'dataTrackingId' | 'disabled' | 'loading' | 'variant'
  >

export const ConfirmationModalConfirmButton = ({
  disabled,
  loading,
  onConfirm,
  children,
  dataTestId,
  dataTrackingId,
  variant = 'primary',
}: ConfirmationModalConfirmButtonProps) => {
  return (
    <Button
      variant={variant}
      dataTestId={dataTestId}
      dataTrackingId={dataTrackingId}
      disabled={disabled}
      loading={loading}
      onClick={onConfirm}
    >
      {children}
    </Button>
  )
}
